<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg aria-hidden="true">
        <use href="assets/icons.svg#geo-marker"></use>
      </svg>
      <span>Select lead prospect</span>
    </h3>
  </div>
  <div class="card-content">
    <div class="content-section">
      <div class="card-intro">
        <svg aria-hidden="true">
          <use href="assets/icons.svg#people"></use>
        </svg>
        <p>Select a lead from Upper Heyford area to begin the sales process</p>
      </div>

      <!-- Controls Grid 2x2 -->
      <div class="controls-grid two-one-grid">
        <div class="form-field">
          <label for="search" class="field-label">Search Leads</label>
          <div class="search-input-wrapper">
            <svg aria-hidden="true">
              <use href="assets/icons.svg#searchglass"></use>
            </svg>
            <input
              id="search"
              type="text"
              class="search-input"
              placeholder="Search by address or postcode"
              [(ngModel)]="searchQuery"
              (input)="filterLeads()"
            />
          </div>
        </div>

        <div class="form-field">
          <label class="field-label"><br /></label>
          <opportunities-btn></opportunities-btn>
        </div>
      </div>

      <div class="controls-grid">
        <div class="form-field">
          <label for="sort-select" class="field-label">Sort by</label>
          <select
            id="sort-select"
            class="filter-select"
            [(ngModel)]="sortBy"
            (change)="sortLeads()"
          >
            <option value="voucher">Voucher Value</option>
            <option value="address">Address</option>
            <option value="people">Number of People</option>
          </select>
        </div>

        <div class="form-field">
          <label for="filter-status" class="field-label">Filter Status</label>
          <select
            id="filter-status"
            class="filter-select"
            [(ngModel)]="filterStatus"
            (change)="filterLeads()"
          >
            <option value="">All Statuses</option>
            <option value="new">New</option>
            <option value="low">Low Priority</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Leads List -->
    <div class="leads-list">
      @for (lead of filteredLeads; track lead) {
        <div
          class="lead-card"
          (click)="selectLead(lead)"
          [class.selected]="selectedLead === lead"
          role="button"
          tabindex="0"
          aria-pressed="{{ selectedLead === lead }}"
        >
          <div class="lead-content">
            <div class="lead-main">
              <div class="lead-address-section">
                <h4 class="lead-address">{{ lead.address }}</h4>
                <button
                  class="external-link-btn"
                  type="button"
                  (click)="openMap(lead)"
                  aria-label="Open map for {{ lead.address }}"
                >
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#link"></use>
                  </svg>
                </button>
              </div>
              <p class="lead-detail">{{ lead.postcode }}</p>
              <div class="lead-stats">
                <div class="stat-item">
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#people"></use>
                  </svg>
                  <span>{{ lead.people }} people</span>
                </div>
                <div class="stat-item">
                  <svg aria-hidden="true">
                    <use href="assets/icons.svg#dollar"></use>
                  </svg>
                  <span>{{ lead.value }}</span>
                </div>
              </div>
            </div>
            <div class="lead-badges">
              <span class="badge badge-new">{{ lead.status }}</span>
              <span class="badge badge-priority">{{ lead.priority }}</span>
            </div>
          </div>
        </div>
      }
    </div>

    @if (selectedLead) {
      <div class="selected-lead">
        <h4>Selected Lead:</h4>
        <p>{{ selectedLead.address }}, {{ selectedLead.postcode }}</p>
        <p>{{ selectedLead.value }} voucher • {{ selectedLead.people }} people</p>
      </div>
    }

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button">Check Eligibility</button>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="!selectedLead"
        (click)="goToEligibility()"
      >
        Continue with Lead
      </button>
    </div>
  </div>
</div>
